import React from 'react';
import './PetPreform.css';
import pet1 from '../../../imgs/MedicalP.webp';  
import pet2 from '../../../imgs/siliconep.webp';  


const Medicalp = () => {
  return (
    <div className="petf">
      <div className="petf-card" data-aos="flip-left">
        <img
          src={pet1}
          alt="Pet Preform 1"
          className="petf-img"
        />
        <p className="description-box">This is the description for Pet Preform 1.</p>

      </div>
      <div className="petf-card" data-aos="flip-right">
        <img
          src={pet2}
          alt="Pet Preform 2"
          className="petf-img"
        />      
        <p className="description-box">This is the description for Pet Preform 1.</p>

      </div>
    </div>
  );
};

export default Medicalp;
